
import Effect from "../Effect";
class Overdrive extends Effect {

	constructor(path, number) {
		super("Overdrive", Overdrive.nice_name, path, number);

		var drive = this.createParameter("drive", {name: "Drive", min: 0, max: 100, step: 1});

		var mix = this.createParameter("mix", {name: "Mix", min: 0, max: 100, step: 1});

    mix.on('change', this.handleMixChange.bind(this));

    drive.on('change', this.handleDriveChange.bind(this));

    this.gain1 = false;
    this.gain2 = false;
    this.ws = false;
	}

  handleMixChange(event) {
    if(this.gain1 !== false) {
      this.gain2.gain.setValueAtTime(event.normalized/127, 0);
      this.gain1.gain.setValueAtTime(1-event.normalized/127, 0);
    }
  }

  handleDriveChange(event) {
    if(this.ws !== false) {
      this.ws.curve = this.makeDistortionCurve(event.value);
    }
  }

	createNodes(context) {
		this.ws = context.createWaveShaper();
		this.inputNode = context.createGain();
		this.gain1 = context.createGain();
		this.gain2 = context.createGain();

		this.ws.connect(this.gain2);
		this.inputNode.connect(this.ws);
		this.inputNode.connect(this.gain1);

		this.gain2.gain.setValueAtTime(this.getParameterByName('mix').normalized/127, 0);
		this.gain1.gain.setValueAtTime(1-this.getParameterByName('mix').normalized/127, 0);

		return {
			connect: (node) => {
				this.gain1.connect(node);
        this.gain2.connect(node);
			},
			disconnect: (node) => {
				this.gain1.disconnect(node);
        this.gain2.disconnect(node);
			},
			input: this.inputNode
		};
	}

  makeDistortionCurve (amount) {
    var k = typeof amount === 'number' ? amount : 50,
      n_samples = 44100,
      curve = new Float32Array(n_samples),
      deg = Math.PI / 180,
      i = 0,
      x;
    for ( ; i < n_samples; ++i ) {
      x = i * 2 / n_samples - 1;
      curve[i] = ( 3 + k ) * x * 20 * deg / ( Math.PI + k * Math.abs(x) );
    }
    return curve;
  };

}

Overdrive.nice_name = "Overdrive";

export default Overdrive;
